export const DEFAULT_RESPONSE_FIELDS: { [key: string]: object } = {
  transactionId: {
    order: 10,
    label: 'Transaction ID',
    mapping: 'response.transaction_id',
    showOnSuccess: true
  },
  receipt: {
    order: 20,
    label: 'Receipt',
    showOnSuccess: true
  },
  token: {
    order: 30,
    label: 'Token',
    showOnSuccess: false
  },
  errorMessage: {
    order: 100,
    label: 'Error Message',
    mapping: 'response.error_message',
    showOnFailure: false
  },
  errorCode: {
    order: 110,
    label: 'Error Code',
    mapping: 'response.error_code',
    showOnFailure: false
  },
  anotherTransaction: {
    order: 200,
    label: 'Another Transaction',
    action: 'retryClearCVV',
    showOnSuccess: true,
    showOnFailure: true,
    component: 'button'
  }
}
